import { NetworkStatus, useQuery } from '@apollo/client';
import { useCallback } from 'react';

import {
  GET_RD_EXPENSE_PROJECT_ALLOCATION_REPORT,
  GetRdExpenseProjectAllocationReportQuery,
  GetRdExpenseProjectAllocationReportQueryVariables,
  ProviderType,
} from '@neo.tax/shared/graphql';
import { downloadFileByUrl } from '@neo.tax/shared/utils';

export const useGetRdExpenseProjectAllocationReport = (
  fiscalYearId: string,
  providerType: ProviderType,
): {
  download: () => Promise<void>;
  loading: boolean;
} => {
  const { networkStatus, refetch } = useQuery<
    GetRdExpenseProjectAllocationReportQuery,
    GetRdExpenseProjectAllocationReportQueryVariables
  >(GET_RD_EXPENSE_PROJECT_ALLOCATION_REPORT, { fetchPolicy: 'network-only', skip: true });

  const download = useCallback(async (): Promise<void> => {
    const { data } = await refetch({ fiscalYearId, providerType });
    const { signedUrl } = data.getRdExpenseProjectAllocationReport;
    if (!signedUrl) {
      return;
    }
    // The file name here is irrelevant. The file will be downloaded as the original name uploaded to GCP Cloud Storage.
    downloadFileByUrl(signedUrl, 'allocation-report.xlsx');
  }, [fiscalYearId, refetch, providerType]);

  return {
    download,
    loading: networkStatus === NetworkStatus.loading,
  };
};
